import React from 'react';
import { RowHeaderTable, TableUsersInAdmin } from '../../components';

const UsersAdmin: React.FC = () => {
  return (
    <div className="container-body no-padding">
      <RowHeaderTable
        name="Usuários"
        navigationPath="/home/users-admin/create"
      />
      <TableUsersInAdmin />
    </div>
  );
};

export default UsersAdmin;
